(function($) {
  $(function(){
  
    // Can delete
    var infoWindows = [];
    function closeAllInfoWindows() {
      for (var i=0;i<infoWindows.length;i++) {
         infoWindows[i].close();
      }
    }
  
  
    function new_map($el) {
      var $markers = $el.find('.marker');
  
      var styles = [
        {
            "featureType": "all",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#80909B"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#80909B"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                } 
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#F0EDEE" 
                }
            ]
        }
      ];
  
      var args = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        styles: styles
      };
  
      var map = new google.maps.Map($el[0], args);
  
      map.markers = [];
  
      $markers.each(function(){
        add_marker($(this), map);
      });
  
      center_map(map);
  
      // Trigger a click on the 1st pin, which sets its state to active, opens the infowindow and shows the location info
      // google.maps.event.trigger(map.markers[0], 'click');
  
      google.maps.event.addListenerOnce(map, 'idle', function () {
        console.log('map ready');
        google.maps.event.trigger(map.markers[0], 'click');
      });
  
      return map;
    }
  
  
    $('#mapprev').on('click', function(e){
      e.preventDefault();
      var current_num = parseInt($('.contact-location:visible').attr('data-keyindex'));
      var max_num = (parseInt($('.contact-location').length) - 1);
      var prev_num = (current_num == 0) ? max_num : current_num - 1;
      google.maps.event.trigger(map.markers[prev_num], 'click');
    });
  
    $('#mapnext').on('click', function(e){
      e.preventDefault();
      var current_num = parseInt($('.contact-location:visible').attr('data-keyindex'));
      var max_num = (parseInt($('.contact-location').length) - 1);
      var next_num = (max_num == current_num) ? 0 : current_num + 1;
      google.maps.event.trigger(map.markers[next_num], 'click');
    });
  
    function add_marker($marker, map) {
      var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
      var title = $marker.attr('data-title');
  
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="42.015" height="51.889" viewBox="0 0 42.015 51.889"><g id="Group_2943" data-name="Group 2943" transform="translate(-1.852 -0.794)"><path id="Path_10641" data-name="Path 10641" d="M22.859.794A21.026,21.026,0,0,0,1.852,21.8c0,7.963,5.161,15.547,10.2,21.208a76.615,76.615,0,0,0,10.069,9.429,1.24,1.24,0,0,0,1.48,0,76.615,76.615,0,0,0,10.069-9.429c5.035-5.66,10.2-13.245,10.2-21.208A21.026,21.026,0,0,0,22.859.794Zm0,2.471A18.515,18.515,0,0,1,41.391,21.8c0,6.865-4.717,14.109-9.565,19.564a63.281,63.281,0,0,1-8.967,8.4,62.922,62.922,0,0,1-8.958-8.4C9.049,35.91,4.323,28.666,4.323,21.8A18.519,18.519,0,0,1,22.859,3.265Z" transform="translate(0 0)" fill="#00a2ff"/><path id="Path_10642" data-name="Path 10642" d="M13.147,3.44A8.841,8.841,0,0,0,4.5,12.089a8.833,8.833,0,0,0,8.649,8.645,8.829,8.829,0,0,0,8.645-8.645A8.837,8.837,0,0,0,13.147,3.44Zm0,2.466a6.579,6.579,0,0,1,6.183,6.183,6.583,6.583,0,0,1-6.183,6.183,6.587,6.587,0,0,1-6.188-6.183A6.583,6.583,0,0,1,13.147,5.906Z" transform="translate(9.712 9.712)" fill="#00a2ff"/></g></svg>';
  
      var marker = new RichMarker({
        position: latlng,
        map: map,
        content: '<div class="contact-map-pin" data-title="'+ title +'"></div>',
        shadow: 0,
        title: title,
        anchor: RichMarkerPosition.BOTTOM
      });
  
      map.markers.push(marker);
  
      if ($marker.html()) {
        // Can delete
        var infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });
  
        infoWindows.push(infowindow);
  
        google.maps.event.addListener(marker, 'click', function() {
          // map.setCenter(marker.getPosition()); // Snaps to center
          map.panTo(marker.getPosition()); // Animated to center
  
          $('.contact-map-pin').removeClass('active');
          $('.contact-map-pin[data-title="'+ marker.title +'"]').addClass('active');
  
          // Can delete
          closeAllInfoWindows();
          // infowindow.open(map, marker);
  
          // Change the text box
          // `marker.title` is `[data-localinfo]`
          $('.contact-location:not([data-localinfo="'+ marker.title +'"])').fadeOut(200);
          setTimeout(function(){
            $('.contact-location[data-localinfo="'+ marker.title +'"]').fadeIn(200);
          }, 210);
  
        });
      }
    }
  
    function center_map(map) {
      var latlng = new google.maps.LatLng(map.markers[0].position.lat(), map.markers[0].position.lng());
      map.setCenter(latlng);
      map.setZoom(3);
    }
  
    var map = null;
  
    $(document).ready(function(){
  
      if ($('.acf-map').length) {
        // THis is the magic that enables the RichMarker, which lets us use HTML to create map pins
        (function(){var b=true,f=false;function g(a){var c=a||{};this.d=this.c=f;if(a.visible==undefined)a.visible=b;if(a.shadow==undefined)a.shadow="7px -3px 5px rgba(88,88,88,0.7)";if(a.anchor==undefined)a.anchor=i.BOTTOM;this.setValues(c)}g.prototype=new google.maps.OverlayView;window.RichMarker=g;g.prototype.getVisible=function(){return this.get("visible")};g.prototype.getVisible=g.prototype.getVisible;g.prototype.setVisible=function(a){this.set("visible",a)};g.prototype.setVisible=g.prototype.setVisible;
        g.prototype.s=function(){if(this.c){this.a.style.display=this.getVisible()?"":"none";this.draw()}};g.prototype.visible_changed=g.prototype.s;g.prototype.setFlat=function(a){this.set("flat",!!a)};g.prototype.setFlat=g.prototype.setFlat;g.prototype.getFlat=function(){return this.get("flat")};g.prototype.getFlat=g.prototype.getFlat;g.prototype.p=function(){return this.get("width")};g.prototype.getWidth=g.prototype.p;g.prototype.o=function(){return this.get("height")};g.prototype.getHeight=g.prototype.o;
        g.prototype.setShadow=function(a){this.set("shadow",a);this.g()};g.prototype.setShadow=g.prototype.setShadow;g.prototype.getShadow=function(){return this.get("shadow")};g.prototype.getShadow=g.prototype.getShadow;g.prototype.g=function(){if(this.c)this.a.style.boxShadow=this.a.style.webkitBoxShadow=this.a.style.MozBoxShadow=this.getFlat()?"":this.getShadow()};g.prototype.flat_changed=g.prototype.g;g.prototype.setZIndex=function(a){this.set("zIndex",a)};g.prototype.setZIndex=g.prototype.setZIndex;
        g.prototype.getZIndex=function(){return this.get("zIndex")};g.prototype.getZIndex=g.prototype.getZIndex;g.prototype.t=function(){if(this.getZIndex()&&this.c)this.a.style.zIndex=this.getZIndex()};g.prototype.zIndex_changed=g.prototype.t;g.prototype.getDraggable=function(){return this.get("draggable")};g.prototype.getDraggable=g.prototype.getDraggable;g.prototype.setDraggable=function(a){this.set("draggable",!!a)};g.prototype.setDraggable=g.prototype.setDraggable;
        g.prototype.k=function(){if(this.c)this.getDraggable()?j(this,this.a):k(this)};g.prototype.draggable_changed=g.prototype.k;g.prototype.getPosition=function(){return this.get("position")};g.prototype.getPosition=g.prototype.getPosition;g.prototype.setPosition=function(a){this.set("position",a)};g.prototype.setPosition=g.prototype.setPosition;g.prototype.q=function(){this.draw()};g.prototype.position_changed=g.prototype.q;g.prototype.l=function(){return this.get("anchor")};g.prototype.getAnchor=g.prototype.l;
        g.prototype.r=function(a){this.set("anchor",a)};g.prototype.setAnchor=g.prototype.r;g.prototype.n=function(){this.draw()};g.prototype.anchor_changed=g.prototype.n;function l(a,c){var d=document.createElement("DIV");d.innerHTML=c;if(d.childNodes.length==1)return d.removeChild(d.firstChild);else{for(var e=document.createDocumentFragment();d.firstChild;)e.appendChild(d.firstChild);return e}}function m(a,c){if(c)for(var d;d=c.firstChild;)c.removeChild(d)}
        g.prototype.setContent=function(a){this.set("content",a)};g.prototype.setContent=g.prototype.setContent;g.prototype.getContent=function(){return this.get("content")};g.prototype.getContent=g.prototype.getContent;
        g.prototype.j=function(){if(this.b){m(this,this.b);var a=this.getContent();if(a){if(typeof a=="string"){a=a.replace(/^\s*([\S\s]*)\b\s*$/,"$1");a=l(this,a)}this.b.appendChild(a);var c=this;a=this.b.getElementsByTagName("IMG");for(var d=0,e;e=a[d];d++){google.maps.event.addDomListener(e,"mousedown",function(h){if(c.getDraggable()){h.preventDefault&&h.preventDefault();h.returnValue=f}});google.maps.event.addDomListener(e,"load",function(){c.draw()})}google.maps.event.trigger(this,"domready")}this.c&&
        this.draw()}};g.prototype.content_changed=g.prototype.j;function n(a,c){if(a.c){var d="";if(navigator.userAgent.indexOf("Gecko/")!==-1){if(c=="dragging")d="-moz-grabbing";if(c=="dragready")d="-moz-grab"}else if(c=="dragging"||c=="dragready")d="move";if(c=="draggable")d="pointer";if(a.a.style.cursor!=d)a.a.style.cursor=d}}
        function o(a,c){if(a.getDraggable())if(!a.d){a.d=b;var d=a.getMap();a.m=d.get("draggable");d.set("draggable",f);a.h=c.clientX;a.i=c.clientY;n(a,"dragready");a.a.style.MozUserSelect="none";a.a.style.KhtmlUserSelect="none";a.a.style.WebkitUserSelect="none";a.a.unselectable="on";a.a.onselectstart=function(){return f};p(a);google.maps.event.trigger(a,"dragstart")}}
        function q(a){if(a.getDraggable())if(a.d){a.d=f;a.getMap().set("draggable",a.m);a.h=a.i=a.m=null;a.a.style.MozUserSelect="";a.a.style.KhtmlUserSelect="";a.a.style.WebkitUserSelect="";a.a.unselectable="off";a.a.onselectstart=function(){};r(a);n(a,"draggable");google.maps.event.trigger(a,"dragend");a.draw()}}
        function s(a,c){if(!a.getDraggable()||!a.d)q(a);else{var d=a.h-c.clientX,e=a.i-c.clientY;a.h=c.clientX;a.i=c.clientY;d=parseInt(a.a.style.left,10)-d;e=parseInt(a.a.style.top,10)-e;a.a.style.left=d+"px";a.a.style.top=e+"px";var h=t(a);a.setPosition(a.getProjection().fromDivPixelToLatLng(new google.maps.Point(d-h.width,e-h.height)));n(a,"dragging");google.maps.event.trigger(a,"drag")}}function k(a){if(a.f){google.maps.event.removeListener(a.f);delete a.f}n(a,"")}
        function j(a,c){if(c){a.f=google.maps.event.addDomListener(c,"mousedown",function(d){o(a,d)});n(a,"draggable")}}function p(a){if(a.a.setCapture){a.a.setCapture(b);a.e=[google.maps.event.addDomListener(a.a,"mousemove",function(c){s(a,c)},b),google.maps.event.addDomListener(a.a,"mouseup",function(){q(a);a.a.releaseCapture()},b)]}else a.e=[google.maps.event.addDomListener(window,"mousemove",function(c){s(a,c)},b),google.maps.event.addDomListener(window,"mouseup",function(){q(a)},b)]}
        function r(a){if(a.e){for(var c=0,d;d=a.e[c];c++)google.maps.event.removeListener(d);a.e.length=0}}
        function t(a){var c=a.l();if(typeof c=="object")return c;var d=new google.maps.Size(0,0);if(!a.b)return d;var e=a.b.offsetWidth;a=a.b.offsetHeight;switch(c){case i.TOP:d.width=-e/2;break;case i.TOP_RIGHT:d.width=-e;break;case i.LEFT:d.height=-a/2;break;case i.MIDDLE:d.width=-e/2;d.height=-a/2;break;case i.RIGHT:d.width=-e;d.height=-a/2;break;case i.BOTTOM_LEFT:d.height=-a;break;case i.BOTTOM:d.width=-e/2;d.height=-a;break;case i.BOTTOM_RIGHT:d.width=-e;d.height=-a}return d}
        g.prototype.onAdd=function(){if(!this.a){this.a=document.createElement("DIV");this.a.style.position="absolute"}if(this.getZIndex())this.a.style.zIndex=this.getZIndex();this.a.style.display=this.getVisible()?"":"none";if(!this.b){this.b=document.createElement("DIV");this.a.appendChild(this.b);var a=this;google.maps.event.addDomListener(this.b,"click",function(){google.maps.event.trigger(a,"click")});google.maps.event.addDomListener(this.b,"mouseover",function(){google.maps.event.trigger(a,"mouseover")});
        google.maps.event.addDomListener(this.b,"mouseout",function(){google.maps.event.trigger(a,"mouseout")})}this.c=b;this.j();this.g();this.k();var c=this.getPanes();c&&c.overlayImage.appendChild(this.a);google.maps.event.trigger(this,"ready")};g.prototype.onAdd=g.prototype.onAdd;
        g.prototype.draw=function(){if(!(!this.c||this.d)){var a=this.getProjection();if(a){var c=this.get("position");a=a.fromLatLngToDivPixel(c);c=t(this);this.a.style.top=a.y+c.height+"px";this.a.style.left=a.x+c.width+"px";a=this.b.offsetHeight;c=this.b.offsetWidth;c!=this.get("width")&&this.set("width",c);a!=this.get("height")&&this.set("height",a)}}};g.prototype.draw=g.prototype.draw;g.prototype.onRemove=function(){this.a&&this.a.parentNode&&this.a.parentNode.removeChild(this.a);k(this)};
        g.prototype.onRemove=g.prototype.onRemove;var i={TOP_LEFT:1,TOP:2,TOP_RIGHT:3,LEFT:4,MIDDLE:5,RIGHT:6,BOTTOM_LEFT:7,BOTTOM:8,BOTTOM_RIGHT:9};window.RichMarkerPosition=i;
        })();
  
        $('.acf-map').each(function(){
          map = new_map($(this));
        });
      }
    });
  
  });
  })(jQuery);
